import { BodyText, BodyTextElement, BodyTextProps } from '@farol-ds/react'
import classNames from 'classnames'
import { useContext } from 'react'

import { PriceContext } from './context'
import styles from './price-helptext.module.scss'

export type PriceHelptextElement = BodyTextElement

export type PriceHelptextProps = BodyTextProps

function PriceHelptext(props: PriceHelptextProps) {
  const { children, className, ...rest } = props
  const { size } = useContext(PriceContext)
  const classes = classNames(
    styles.root,
    {
      [styles[`size${size}`]]: !!size,
    },
    className
  )
  return (
    <BodyText {...rest} size={size} asChild>
      <span className={classes} {...rest}>
        {children}
      </span>
    </BodyText>
  )
}

export default PriceHelptext
